import { merge } from 'lodash';

/**
 * Trasforma una lista di oggetti { key: value } in un unico oggetto.
 *
 * Shortcut di `merge({}, ...input)`.
 */
export function mergeList(input: any[]) {
  return merge({}, ...input);
}
